import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageInfoUpdate = async (body: string) => {
  for (let i = 0; i < 3; i++) {
    try {
      //console.log("body");
      //console.log(body);
      const response = await axios.post(`${API_BASE_URL}/info/update`, {
        session_code: localStorage.getItem("session_code"),
        body: body
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
